// extracted by mini-css-extract-plugin
module.exports = {"root":"filter-trigger_root__SOd6S"};